import { useContext, useState } from 'react';
import QuizContext from '../../QuizContext';
import Question from './Question';
import QuizComplete from './QuizComplete';

const Quiz = () => {
  const { gamePlay, setNewGame, setQuestions, setLevel, setCategory } = useContext(QuizContext);

  const { questions: questionBank, category, player, level } = gamePlay;

  const [quesNumber, setQuesNumber] = useState(0);
  const [score, setScore] = useState(0);
  const [clicked, setClicked] = useState(false);
  const [showScore, setShowScore] = useState(false);
  const [currentCorrectAnswer, setCurrentCorrectAnswer] = useState('');
  const [userAnswer, setUserAnswer] = useState('');

  const handleAnswer = answer => {
    const correctAnswer = questionBank[quesNumber].correct_answer;
    setCurrentCorrectAnswer(correctAnswer);
    setUserAnswer(answer);
    if (answer === questionBank[quesNumber].correct_answer) {
      setScore(prevState => prevState + 1);
    }
    setClicked(true);
  };

  const handleNextQuestion = () => {
    setClicked(false);
    if (quesNumber < questionBank?.length - 1) {
      setQuesNumber(prevState => prevState + 1);
    } else {
      setShowScore(true);
    }
  };

  const resetGame = () => {
    setShowScore(false);
    setClicked(false);
    setScore(0);
    setQuesNumber(0);
  };

  const handleNewGame = () => {
    resetGame();

    setNewGame();
    setQuestions([]);
    setLevel('');
    setCategory({});
  };

  const buttonLabel = !clicked ? 'Try your best!' : quesNumber + 1 !== questionBank.length ? 'Next Question' : 'Show score';

  const div = gamePlay.questions?.length && (
    <div className="on-mobile is-flex is-flex-direction-column is-flex-wrap-wrap is-justify-content-space-between p-5">
      {showScore ? (
        <QuizComplete questionBank={questionBank} category={category} player={player} level={level} score={score} onReset={resetGame} onNewGame={handleNewGame} />
      ) : (
        <>
          <div className="is-flex is-flex-direction-row-reverse	is-justify-content-space-between is-size-7 mb-4">
            <p>
              {category.name} {quesNumber + 1} / {questionBank?.length}
            </p>
            <p>Score: {score}</p>
          </div>
          <Question
            question={questionBank[quesNumber].question}
            choices={questionBank[quesNumber].choices}
            onAnswer={handleAnswer}
            onNextQuestion={handleNextQuestion}
            correctAnswer={currentCorrectAnswer}
            userAnswer={userAnswer}
            clicked={clicked}
            nextButtonLabel={buttonLabel}
          />
        </>
      )}
    </div>
  );

  return div || '';
};

export default Quiz;
